import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { Table, Modal } from "react-bootstrap";
import AddFeedback from "./components/AddFeedback";
import UploadContract from "./components/UploadAssessment";
import ContributionForm from "./components/ContributionForm";

function TeamPerformance() {
  const { selectedUser, year, setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [showAddFeedbackModal, setShowAddFeedbackModal] = useState(false);
  const [UploadModel, setUploadModel] = useState(false);
   const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [showRoleModal, setShowRoleModal] = useState(false);
  const [roleType, setRoleType] = useState("");
  const [roleDetails, setRoleDetails] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [showContributionForm, setShowContributionForm] = useState(false);

    function RevenueCounter({ value, format = true }) {
        const safeValue = Number(value) || 0;
        return (
            <CountUp
                start={0}
                end={safeValue}
                duration={1}
                formattingFn={format ? currency_converter_inr : undefined}
            />
        );
    }  

    const getOverview = async (signal = null) => {
        if (!selectedUser) return;
        try {
        setGlobalLoading(true);

        // ✅ Clear old data immediately
        setData([]);

        const response = await axios.get(
            `${REACT_APP_API_BASE_URL}/performance/team_performances`,
            {
            params: { user_id: selectedUser.id, year: year },
            headers: { Authorization: `Bearer ${token}` },
            signal: signal, // ✅ IMPORTANT
            }
        );

        const d = response.data;

        if (response.status === 200) {
            const activityMap = {
            "Search strategy ideation & execution": "Search Strategy",
            "Documentation – JD, candidate deck etc": "Documentation",
            "Offer Negotiation - candidate": "Negotiation",
            "Offer Negotiation - client": "Offer Negotiation",
            };

            const heatmap = d.heatmap || [];

            const formattedData = heatmap.map((item) => ({
            activity: activityMap[item.activity] || item.activity,
            values: [
                item.Associate ?? 0,
                item.Consultant ?? 0,
                item.Sr_Consultant ?? 0,
            ],
            }));

            const users = d.individual_heatmap || [];
            const formatted = users.map(user => ({
            id: user.user_id,    
            name: user.firstname,
            designation: user.designation,
            total: user.total_roles,
            total_closed: user.closed_count,
            contribution: user.contribution_percent,
            closed_role_list: user.closed_role_list,
            total_role_list: user.total_role_list,
            values: [
                user.Research || 0,
                user.Candidate_Briefing || 0,
                user.Candidate_Evaluation || 0,
                user.Search_Strategy || 0,
                user.Documentation || 0,
                user.Client_Coordination || 0,
                user.Negotiation || 0,
                user.Client_Management || 0,
                user.Client_Negotiation || 0
            ]
            }));


            setData({
            ...d,
            options: formattedData,
            formatted
            });
        }
        } catch (error) {
        // ✅ Ignore cancelled requests
        if (axios.isCancel(error)) {
            console.log("Request cancelled");
        } else {
            console.log(error);
        }
        } finally {
        setGlobalLoading(false);
        }
    };

    useEffect(() => {
        const controller = new AbortController();

        getOverview(controller.signal);

        return () => controller.abort();
    }, [selectedUser?.id, year]);
  
    const headers = [
    "Associate",
    "Consultant",
    "Sr. Consultant",
    ];

    const activityHeaders = [
        "Research",
        "Briefing",
        "Evaluation",
        "Strategy",
        "Documentation",
        "Client Coordination",
        "Negotiation - candidate",
        "Client Mgmt",
        "Negotiation - client"
        ];

    const getColor = (value) => {
    const opacity = value / 100;
    // return `rgba(220, 53, 69, ${opacity})`; // bootstrap danger color
    return `rgba(20, 184, 165, ${opacity})`; // bootstrap danger color
    };

    const openRoleModal = async (roleIds, reviewedRoleIds, user_id, type ) => {
        if (!roleIds) return;
        try {
            setGlobalLoading(true);
            const response = await axios.get(
                `${REACT_APP_API_BASE_URL}/performance/role_list`,
                {
                    params: {
                        role_ids: roleIds,
                        reviewed_role_ids: reviewedRoleIds,
                        user_id: user_id
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            setRoleDetails(response.data.role_details);
            setRoleType(type);
            setShowRoleModal(true);
        } finally {
            setGlobalLoading(false);
        }
    };

    const openContributionForm = (role) => {
        setSelectedRoleId(role.id);
        setSelectedCandidateId(role.candidate_id);

        // Close role list modal
        setShowRoleModal(false);

        // Open contribution form
        setShowContributionForm(true);
    };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="border-bottom mb-3 pb-3">
            <h4>Team Performance</h4>
            <p className="text-muted fs-13 mb-1">
                Team capability, workload & readiness
            </p>
            {year === '2025 - 2026' && (
               <div className="d-flex justify-content-end gap-2">
                <button
                className="btn btn-sm btn-primary"
                type="button"
                onClick={() => setShowAddFeedbackModal(true)}
                >
                <i className="fa-solid fa-plus me-1"></i> Final Year Feedback
                </button>

                {user?.designation_id >= 2 && user?.designation_id <= 4 && (
                <button
                    className="btn btn-sm btn-primary"
                    type="button"
                    onClick={() => setUploadModel(true)}
                >
                    <i className="fa-solid fa-plus me-1"></i> Self Assessment
                </button>
                )}
            </div> 
            )}
            
          </div>
          <Modal show={showRoleModal} onHide={() => setShowRoleModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{roleType}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered hover responsive size="sm" className="mb-0 align-middle text-nowrap">
                        <thead className="table-light">
                            <tr>
                                <th className="py-1 px-2">Role ID</th>
                                <th className="py-1 px-2">Role</th>
                                <th className="py-1 px-2">Company</th>
                                <th className="py-1 px-2">Status</th>
                                <th className="py-1 px-2">Contribution</th>
                                <th className="py-1 px-2">Role Manager</th>
                                <th className="py-1 px-2">Candidates</th>
                            </tr>
                        </thead>
                        <tbody>
                            {roleDetails.map(role => (
                                <tr key={role.id}>
                                    <td className="py-1 px-2">{role.id}</td>
                                    <td className="py-1 px-2">
                                        <span
                                            className="text-primary" style={{cursor: "pointer", textDecoration: "underline"}}
                                            onClick={() => openContributionForm(role)}
                                        >
                                            {role.role_name}
                                        </span>
                                    </td>
                                    <td className="py-1 px-2">{role.company_name}</td>
                                    <td className="py-1 px-2">
                                        {role.reviewed ? (
                                            <span className="badge bg-success">Reviewed</span>
                                        ) : (
                                            <span className="badge bg-warning text-dark">Pending</span>
                                        )}
                                    </td>
                                    <td className="py-1 px-2">{role.reviewed ? role.contribution : ('-')}</td>
                                    <td className="py-1 px-2">{role.role_manager}</td>
                                    <td className="py-1 px-2">{role.candidate_name}</td>
                                </tr>

                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
          </Modal>  
          {showContributionForm && (
                <ContributionForm
                    role_id={selectedRoleId}
                    candidate_id={selectedCandidateId}
                    onClose={(refresh = 0) => {
                        setShowContributionForm(false);
                        if (refresh) {
                            getOverview();
                        }
                    }}
                />
            )}                  
          {showAddFeedbackModal && (
            <AddFeedback
                show={showAddFeedbackModal}
                onClose={() => {
                setShowAddFeedbackModal(false);
                }}
                user_id={selectedUser?.id}
                year={year}
                token={token}
                onSuccess={async () => {
                setShowAddFeedbackModal(false);
                }}
            />
            )}

          {UploadModel && (
              <UploadContract
                onClose={(data) => {
                  setUploadModel(false);
                }}
                user_id={user?.id}
                designation_id={user?.designation_id}
                year={'2025-2026'}
                token={token}
              />
            )}  
          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-users`}></i>
                                Team Size
                            </p>
                            <h3 className="counter"><RevenueCounter value={data?.team?.[0]?.size || 0} format={false}/></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-award`}></i>
                                Total Closures
                            </p>
                            <h3 className="counter"><RevenueCounter value={data?.closed_roles?.[0]?.closed_count || 0} format={false} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-solid fa-arrow-trend-up`}></i>
                                Reviewed
                            </p>
                            <h3 className="counter"><RevenueCounter value={data?.reviewed_roles?.[0]?.role_count || 0}format={false} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-solid fa-bullseye`}></i>
                                Feedback Given
                            </p>
                            <h3 className="counter text-warning"><RevenueCounter value={data?.feedback_given?.[0]?.count || 0} format={false} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
          </div>
          {/* <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                <h5>Activity Contribution Heat Map (<span className="counter text-success"><RevenueCounter value={data?.reviewed_roles?.[0]?.role_count || 0} format={false} /></span>)</h5>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-6">
                <Table borderless responsive size="sm">
                    <thead>
                    <tr>
                        <th>Activity</th>
                        {headers.map((h, i) => (
                        <th key={i} className="text-center">{h}</th>
                        ))}
                    </tr>
                    </thead>

                    <tbody>
                    {data?.options?.map((row, i) => (
                        <tr key={i}>
                        <td>{row.activity}</td>

                        {row.values.map((val, idx) => (
                            <td key={idx} className="text-center">
                            <div
                                style={{
                                backgroundColor: getColor(val),
                                borderRadius: "8px",
                                padding: "4px 8px",
                                minHeight: "28px",
                                color: val > 60 ? "#fff" : "#000",
                                fontWeight: "500",
                                }}
                            >
                                {val}
                            </div>
                            </td>
                        ))}
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
          </div>  */}

        <hr className="my-4" />
        <div className="d-flex align-items-center flex-wrap row-gap-2 mb-3">
        <h5 className="mb-0">Individual Heat Map</h5>
        </div>      
        {/* HEADER */}
            <div
            style={{
                display: "grid",
                gridTemplateColumns: "130px repeat(9, 1fr)",
                gap: "8px",
                marginBottom: "10px",
                fontWeight: "600",
                fontSize: "12px"
            }}
            >
            <div>Team Member</div>
            {activityHeaders.map((header, i) => (
                <div key={i} style={{ textAlign: "center" }}>
                {header}
                </div>
            ))}
            </div>

            {/* ROWS */}
            {data?.formatted?.map((user, i) => (
            <div
                key={i}
                style={{
                display: "grid",
                gridTemplateColumns: "130px repeat(9, 1fr)",
                gap: "8px",
                alignItems: "center",
                padding: "6px 0",
                borderBottom: "1px solid #eee"
                }}
            >
                {/* USER INFO */}
                <div>
                <div className="d-flex align-items-center">
                <strong>{user.name}</strong>
                </div>

                {/* designation in next line */}
                <div
                    className={`badge fs-10 mt-1 ${
                    user.designation === "Associate"
                        ? "bg-outline-info text-info"
                        : (user.designation === "Consultant" || user.designation === "Accelerate Trainee")
                        ? "bg-outline-warning text-warning"
                        : user.designation === "Senior Consultant"
                        ? "bg-outline-primary text-primary"
                        : "bg-light text-muted"
                    }`}
                >
                    {user.designation}
                </div>

                <div className="text-muted fs-12 mt-1">
                    {user.contribution}% Contribution
                </div>
                {/* <div className="text-muted fs-12 mt-1">
                    {user.total_closed} closed / {user.total} reviewed
                </div> */}
                <div className="text-muted fs-12 mt-1">
                    <span className="text-primary" style={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => openRoleModal(user.closed_role_list, user.total_role_list, user.id, "Closed Roles")}
                    >
                        {user.total_closed} closed
                    </span>

                    {" / "}

                    <span>{user.total} reviewed</span>
                
                </div>
                </div>

                {/* VALUES */}
                {user.values.map((val, idx) => (
                <div
                    key={idx}
                    style={{
                    textAlign: "center",
                    padding: "4px",
                    borderRadius: "8px",
                    backgroundColor: getColor(val),
                    color: val > 60 ? "#fff" : "#000",
                    fontWeight: "500"
                    }}
                >
                    {val ? `${val}%` : "-"}
                </div>
                ))}
            </div>
            ))}
         
        </div>
      </div>
    </>
  );
}

export default TeamPerformance;